import Highlighter from '../util/Highlighter';

export function searchHighlight() {
  const hash = window.location.hash;

  if(hash && hash.startsWith('#s-')){
    const searchValue = hash.replace('#s-', '');

    var highlight = new Highlighter('content');
    highlight.setMatchType('open');
    highlight.apply(searchValue);

    $( window ).on( 'hashchange', function() {
      const hash = window.location.hash;

      const searchValue = hash.replace('#s-', '');

      var highlight = new Highlighter('content');
      highlight.setMatchType('open');
      highlight.apply(searchValue);
    } );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/search-highlight.js